module.exports = __webpack_public_path__ + "static/media/linkedin.7ab43307.png";